/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import {
  Checkbox,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  setSelectedWorkFlowRoles,
  setUserAccessRolesModified
} from "../../redux/actions/userAccount-actions/workFlowRoles-action";

export const WorkFlow = (props) => {
  const {
    workFlowType,
    roles,
    // affiliateType, 
    selectedRoles,
    userAccessResources, 
    allAffiliatesResources 
  } = props;

  const dispatch = useDispatch();
  const [rolesSelected, setRolesSelected] = useState([]);
  const [activeRoleSection] = useState(1);
  const totalRoles = roles?.length || 0;
  const rolesPerSection = totalRoles;

  const displayRoles = useMemo(() => {
    if (!roles || !roles.length) return [];

    const byName = (a, b) => (a?.name || "").localeCompare(b?.name || "");

    // const isSelected = (role) =>
    //   (rolesSelected || []).some(
    //     (rle) =>
    //       rle.workFlowType === workFlowType &&
    //       rle.role?.vam_role_id === role?.vam_role_id
    //   );

    // const selected = roles.filter(isSelected).sort(byName);
    // const unselected = roles.filter((r) => !isSelected(r)).sort(byName);
    const ordered = roles.sort(byName);

    return ordered.slice(
      (activeRoleSection - 1) * rolesPerSection,
      activeRoleSection * rolesPerSection
    );
  }, [roles, rolesSelected, workFlowType, activeRoleSection, rolesPerSection]);

  let userAccessRoles = [];

  if (
    userAccessResources &&
    Array.isArray(userAccessResources) &&
    userAccessResources.length &&
    allAffiliatesResources &&
    Array.isArray(allAffiliatesResources) &&
    allAffiliatesResources.length
  ) {
    userAccessResources.map((resource) => {
      // const affiliate = allAffiliatesResources?.find(
      //   (affiliate) =>
      //     affiliate?.affiliateType?.abbreviation ===
      //     resource?.user?.vamHubAbbreviation
      // );
      // const affiliateType = affiliate?.affiliateType?.name;

      resource.roles.map((role) => {
        const roleMapToWorkFlowType = {
          // workFlowType: affiliateType,
          role: role
        };
        userAccessRoles.push(roleMapToWorkFlowType);
      });
    });
  }

   useEffect(() => {
    dispatch(setSelectedWorkFlowRoles([...selectedRoles]));
    setRolesSelected(selectedRoles);
  }, []);

  const modifiedWorkFlow = JSON.stringify({ roles: rolesSelected });

  useEffect(() => {
    const modifiedWorkFlowParsed = JSON.parse(modifiedWorkFlow);
    const payload = modifiedWorkFlowParsed.roles;
    dispatch(setSelectedWorkFlowRoles([...payload]));
  }, [modifiedWorkFlow]);

  const changeRoleHandler = (event, role) => {
    const { checked } = event.target;
    let newArr;
    if (typeof checked === "undefined") {
      newArr = rolesSelected?.filter(
        (rle) => rle.role.vam_role_id !== role.vam_role_id
      );
    } else {
      newArr = checked
        ? [...rolesSelected, { workFlowType, role }]
        : rolesSelected?.filter(
            (rle) =>
              rle.workFlowType === workFlowType &&
              rle.role.vam_role_id !== role.vam_role_id
          );
    }
    setRolesSelected(newArr);
    dispatch(setUserAccessRolesModified(true));
  };

  const selectedCountForThisWorkflow = useMemo(
    () =>
      (rolesSelected || []).filter(
        (r) => r.workFlowType === workFlowType && r.role.isActive === true
      ).length,
    [rolesSelected, workFlowType]
  );

  const renderSelectUserRoles = () => {
    return (
      <div className="workflow_selectUserRoles" style={{ margin: "1px" }}>
        <div className="workflow_tableHeaderRow">
          <span className="workflow_selectUserRolesHead">
            Select Your Role(s) 
            {selectedCountForThisWorkflow > 0
              ? ` - ${selectedCountForThisWorkflow}`
              : ""}
          </span>
          <span className="workflow_selectUserRolesHead">Role Description</span>
          <span className="workflow_selectUserRolesHead">Required Training – Refer to VAM User Guide</span>
        </div>

        <div className="workFlow_body">
          <Box className="workflow_tableContainer">
            <Table className="workflow_table" size="small">
              <TableBody>
                {displayRoles && displayRoles.length ? (
                  displayRoles.map((role) => {
                    const isChecked = !!rolesSelected?.find(
                      (rle) =>
                        rle.workFlowType === workFlowType &&
                        rle.role.vam_role_id === role.vam_role_id
                    );                    
                  if (role.isActive === true) {
                    return (
                      <TableRow
                        key={role.vam_role_id}
                        className="workflow_tableRow"
                        hover
                      >
                        {/* Role Name + Checkbox */}
                        <TableCell className="workflow_tableCell equalColumn">
                          <div className="workflow_roleCell">
                            <Checkbox
                              checked={isChecked}
                              onChange={(event) => changeRoleHandler(event, role)}
                              sx={{ "&.Mui-checked": { color: "#00AE43" } }}
                              className="rolesCheckboxClass"
                            />
                            <Typography
                              className="rolesCheckboxLabelClass"
                              style={{
                                fontSize: "0.95rem",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                marginTop: "5px"
                              }}
                            >
                              {(role?.name || "")}
                            </Typography>
                          </div>
                        </TableCell>

                        {/* Description Column */}
                        <TableCell className="workflow_tableCell equalColumn">
                          <Typography
                            className="workflow_roleDescription"
                            style={{
                                fontSize: "0.9rem",                                
                                whiteSpace: "normal",
                                wordBreak: "break-word"
                              }}
                          >
                            {(role?.description || "No description available")}
                          </Typography>
                        </TableCell>

                        {/* Training Column */}
                        <TableCell className="workflow_tableCell equalColumn">
                          {role.trainings.length > 0 ? (
                            <ul className="workflow_trainingList">
                              {role.trainings.map((training, idx) => (
                                <li key={idx} className="workflow_trainingItem">
                                  {(`${training.id} - ${training.trainingName}` || "")}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <Typography
                              className="workflow_trainingEmpty"
                              variant="body2"                              
                            >
                              No trainings available
                            </Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }                  
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={3}
                      className="workflow_tableCell"
                      style={{ textAlign: "center" }}
                    >
                      No roles available.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </div>
      </div>
    );
  };

  return (
    <div className="workFlowCard">
      <div className="workFlowCard_header">
        <span className="workflow_headWithSelection">
          <span>Affiliate</span>
          <span className="workFlow_selected">{workFlowType?.toUpperCase()}</span>
        </span>
      </div>
      {roles?.length ? renderSelectUserRoles() : null}
    </div>
  );
};
